import { render } from "./coach-timedate.vue?vue&type=template&id=540de0a7"
import script from "./coach-timedate.vue?vue&type=script&lang=js"
export * from "./coach-timedate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__